import { ResourceTypeClientModel } from '@apono/client-app-sdk';
import MoreTexts from './MoreTexts';

export default function ResourceTypesCell({ resourceTypes }: { resourceTypes: ResourceTypeClientModel[] }) {
  return <MoreTexts texts={resourceTypes.map((rt) => rt.name)} />;
}
